"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderWrapper = exports.SmallText = exports.Small = exports.Round = exports.Text = exports.OutlinedOnBackground = exports.Outlined = exports.Contained = exports.RawButton = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.RawButton = styled_components_1.default.button `
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  box-sizing: border-box;
  border: 0;
  outline: none;
  min-height: 40px;
  font-family: SwegonBrown;
  font-weight: normal;
  font-size: 14px;

  &:hover:enabled {
    cursor: pointer;
  }
`;
exports.Contained = (0, styled_components_1.default)(exports.RawButton) `
  background-color: ${({ $color }) => $color || colors_1.DARK_GREEN};
  border: 1px solid ${({ $color }) => $color || colors_1.DARK_GREEN};
  color: ${colors_1.WHITE};
  padding: 0 16px;
  justify-content: center;

  ${({ $disabled }) => $disabled &&
    (0, styled_components_1.css) `
      background-color: ${colors_1.LIGHT_GREY};
      border: 1px solid ${colors_1.GREY2};
      color: ${colors_1.GREY2};
    `}

  &:focus-visible:enabled,
    &:hover:enabled {
    background-color: ${({ $color }) => $color || colors_1.SWEGON_GREEN};
    ${({ $color }) => $color &&
    (0, styled_components_1.css) `
        filter: brightness(110%);
      `}
    border-color: ${({ $color }) => $color || colors_1.SWEGON_GREEN};
  }

  &:active:enabled {
    background-color: ${({ $color }) => $color || colors_1.SWEGON_GREEN};
    ${({ $color }) => $color &&
    (0, styled_components_1.css) `
        filter: brightness(90%);
      `}
    border-color: ${({ $color }) => $color || colors_1.SWEGON_GREEN};
  }

  ${({ $showSpinnerOnClick }) => $showSpinnerOnClick &&
    (0, styled_components_1.css) `
      background-color: ${colors_1.LIGHT_GREY};
      border: 1px solid ${colors_1.GREY2};
      cursor: not-allowed;

      &:focus-visible:enabled,
      &:hover:enabled {
        background-color: ${colors_1.LIGHT_GREY};
        border: 1px solid ${colors_1.GREY2};
        cursor: not-allowed;
      }

      &:active:enabled {
        background-color: ${colors_1.LIGHT_GREY};
        border: 1px solid ${colors_1.GREY2};
        cursor: not-allowed;
      }
    `}
`;
exports.Outlined = (0, styled_components_1.default)(exports.RawButton) `
  background-color: ${colors_1.WHITE};
  border: 1px solid ${({ $color }) => $color || colors_1.DARK_GREEN};
  color: ${({ $color }) => $color || colors_1.DARK_GREEN};
  padding: 0 32px;

  ${({ $disabled }) => $disabled &&
    (0, styled_components_1.css) `
      background-color: ${colors_1.WHITE};
      border-color: ${colors_1.GREY2};
      color: ${colors_1.GREY2};
    `}

  &:focus-visible:enabled,
    &:hover:enabled {
    color: ${colors_1.WHITE};
    background-color: ${({ $color }) => $color || colors_1.SWEGON_GREEN};
    border-color: ${({ $color }) => $color || colors_1.SWEGON_GREEN};
  }

  &:active:enabled {
    background-color: ${({ $color }) => $color || colors_1.SWEGON_GREEN};
    border-color: ${({ $color }) => $color || colors_1.SWEGON_GREEN};
    ${({ $color }) => $color &&
    (0, styled_components_1.css) `
        filter: brightness(90%);
      `}
  }
`;
exports.OutlinedOnBackground = (0, styled_components_1.default)(exports.Outlined) `
  background-color: transparent;
  border: 1px solid ${({ $color }) => $color || colors_1.WHITE};
  color: ${({ $color }) => $color || colors_1.WHITE};

  ${({ $disabled }) => $disabled &&
    (0, styled_components_1.css) `
      color: ${colors_1.GREY2};
      border-color: ${colors_1.GREY2};
    `}
`;
exports.Text = (0, styled_components_1.default)(exports.RawButton) `
  background-color: transparent;
  padding: 0 16px;
  color: ${({ $color }) => $color || colors_1.DARK_GREEN};
  ${({ $disabled }) => $disabled &&
    (0, styled_components_1.css) `
      color: ${colors_1.GREY2};
    `}

  &:focus-visible:enabled,
    &:hover:enabled {
    background-color: ${({ $color }) => $color || colors_1.PALE_GREEN};
    color: ${({ $color }) => ($color ? colors_1.WHITE : colors_1.DARK_GREEN)};
  }

  &:active:enabled {
    background-color: ${({ $color }) => $color || colors_1.PALE_GREEN};
    color: ${({ $color }) => ($color ? colors_1.WHITE : colors_1.DARK_GREEN)};
  }
`;
exports.Round = (0, styled_components_1.default)(exports.RawButton) `
  border: 1px solid ${({ $color }) => $color || colors_1.BLACK};
  padding: 10px 16px;
  border-radius: 24px;
  color: ${({ $color }) => $color || colors_1.BLACK};
  background-color: ${colors_1.WHITE};
  ${({ $disabled }) => $disabled &&
    (0, styled_components_1.css) `
      color: ${colors_1.GREY2};
      border-color: ${colors_1.GREY2};
    `}

  &:focus-visible:enabled,
    &:hover:enabled {
    color: ${colors_1.WHITE};
    background-color: ${({ $color }) => $color || colors_1.BLACK};
  }

  &:active:enabled {
    background-color: ${({ $color }) => $color || colors_1.BLACK};
    border-color: ${({ $color }) => $color || colors_1.BLACK};
  }
`;
exports.Small = (0, styled_components_1.default)(exports.Contained) `
  height: 32px;
  padding: 8px;
  font-size: 12px;
  text-transform: none;
`;
exports.SmallText = (0, styled_components_1.default)(exports.Text) `
  height: 32px;
  padding: 8px;
  font-size: 12px;
  text-transform: none;
`;
exports.LoaderWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 80px;

  > div,
  > div div {
    width: 22px !important;
    height: 22px !important;
  }
`;
//# sourceMappingURL=Button.styles.js.map